import UiNotify from 'devextreme/ui/notify';
import * as dialog from 'devextreme/ui/dialog';
import * as excelExporter from 'devextreme/excel_exporter';
import CustomStore from 'devextreme/data/custom_store';

export const dxUiNotify = UiNotify;
export const dxCustomStore = CustomStore;
export const { confirm: dxUiConfirm, alert: dxUiAlert, custom: dxUiCustom } = dialog;

export const { exportDataGrid: dxExportDataGrid } = excelExporter;
